/**
 * Разрыв цикла shared/api → features/auth/entities/auth (FSD).
 * Реализация подставляется из плагина приложения (слой app / Nuxt plugin).
 */
export type ApiTokenUnauthorizedContext = {
  isAdminRequest: boolean
}

export type ApiTokenProactiveContext = {
  url: string
}

export interface ApiTokenBridge {
  handleUnauthorized: (ctx: ApiTokenUnauthorizedContext) => Promise<boolean>
  proactiveBeforeRequest: (ctx: ApiTokenProactiveContext) => Promise<void>
}

let impl: ApiTokenBridge | null = null

export function setApiTokenBridge(bridge: ApiTokenBridge | null): void {
  impl = bridge
}

export function getApiTokenBridge(): ApiTokenBridge | null {
  return impl
}
